import axios from "axios";
import { URL, getUrl } from "@api/constants";
// const mockCustomer = {
//   id: 1,
//   serial: '003B000239',
//   name: 'First test customer',
//   icc_id: '',
//   created: '2019-03-05 15:14:32.894000',
//   channels: [{
//     id: 1,
//     name: 'Channel 1 (with camera)',
//     channelIndex: 0
//   }, {
//     id: 2,
//     name: 'Channel 2 (no camera)',
//     channelIndex: 1
//   }]
// }
class CustomersClient {
  getCustomers(pageNum, pageSize) {
    return axios.get(getUrl(URL.GET_CUSTOMERS_LIST), {
      params: {
        pageNum,
        pageSize
      }
    });
  }
  getCustomer(id) {
    return axios.get(
      getUrl(URL.GET_CUSTOMER, {
        id
      })
    );
  }
  postCustomer(customer) {
    return axios.post(getUrl(URL.POST_CUSTOMER), customer);
  }
  putCustomer(id, customer) {
    return axios.put(
      getUrl(URL.PUT_CUSTOMER, {
        id
      }),
      customer
    );
  }
  putCustomerSecretKey(id) {
    return axios.put(
      getUrl(URL.PUT_CUSTOMER_SECRET_KEY, {
        id
      })
    );
  }
  deleteCustomer(id) {
    return axios.delete(
      getUrl(URL.DELETE_CUSTOMER, {
        id
      })
    );
  }
}

export let customersClient = new CustomersClient();



// WEBPACK FOOTER //
// ./src/api/customers.js